// extracted by mini-css-extract-plugin
export default {"folder_href":"manageFile_folder_href__oM2WM"};